export default {
  CREATING: 'ADMIN_VIEW_MARKET_SPACES_CREATOR_CREATING',
  CREATED: 'ADMIN_VIEW_MARKET_SPACES_CREATOR_CREATED',
};
